export function preventPriceDuplicatesMapper(params) {
  if (params.config.featuresFlags.preventValidPriceDuplicates) {
    return {
      options: {
        preventValidPriceDuplicates: params.config.featuresFlags.preventValidPriceDuplicates
      }
    };
  }
  return {};
}